import { initializeApp, getApps } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import type { Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCkpCTGDqSlrJzggzhS8KyoZ1fQLzKzNiU',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'portal.agent-capital.ai',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'agent-capital-firebase-dev',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'agent-capital-firebase-dev.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '1013446644948',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:1013446644948:web:052def46fff9fc36595741',
};

let auth: Auth | undefined;

function getFirebaseApp(): FirebaseApp {
  const apps = getApps();
  return apps.length === 0 ? initializeApp(firebaseConfig) : apps[0]!;
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    const firebaseApp = getFirebaseApp();
    auth = getAuth(firebaseApp);
    
    const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';
    if (useEmulator) {
      const emulatorUrl = import.meta.env.DEV
        ? window.location.origin
        : (import.meta.env.VITE_FIREBASE_URL || 'http://localhost:9099');
      connectAuthEmulator(auth, emulatorUrl, { disableWarnings: true });
    }
  }
  return auth;
}

export { getFirebaseApp as initializeFirebase };
